import { Typography } from "@packages/ds";
import styled from "styled-components";

import * as Sticker from "ds/Sticker";

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Help = styled.p`
  margin: 16px 0 24px 0;
  line-height: 24px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;
  svg {
    margin: 0 8px 0 0;
    vertical-align: middle;
  }
  span {
    text-transform: lowercase;
  }
`;

export const Info = styled.div`
  padding-top: 8px;
`;

export const GraniteText = styled(Typography.BodyText)`
  color: var(--label-granite-color, var(--granite));
`;

export const GraniteSmallText = styled(Typography.BodyText)`
  font-size: 13px;
  color: var(--label-granite-color, var(--granite));
`;

export const StickerWrapper = styled(Sticker.Root)`
  margin-bottom: 32px;
`;
